/* eslint-disable no-console */
import type { CommonRetryOptions } from '@module-federation/retry-plugin';
import { RetryPlugin } from '@module-federation/retry-plugin';

export const createRetryPlugin = (param?: CommonRetryOptions) => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  return RetryPlugin({
    retryTimes: 10,
    retryDelay: 1000,
    addQuery: true,
    ...(isDevelopment && {
      onRetry: ({ times, url }) => {
        console.log(`[MF Retry] Выполняется попытка ${times} для ${url}`);
      },
      onSuccess: ({ url }) => {
        console.log(`[MF Retry] Успешная загрузка: ${url}`);
      },
      onError: ({ url }) => {
        console.error(`[MF Retry] Ошибка после всех повторных попыток: ${url}`);
      },
    }),
    ...param,
  });
};
